<template>
  <div class="bc-report-summary">
    <type-container
      class="summary"
      title="概述"
    >
      <div
        v-loading="summaryLoading"
        class="summary-slot"
      >
        <span>经过对{{ companyParams.name }}的法律风险体检，我们认为：</span>
        <div>
          <div
            v-for="info in summaryProps"
            :key="info.label"
            class="info-item"
          >
            <div class="label">{{ info.label }}</div>
            <div class="value">{{ summaryInfo[info.key] || '-' }}</div>
          </div>
        </div>
      </div>
    </type-container>
    <type-container
      class="risk"
      title="风险提示"
    >
      <div>
        <div
          v-for="section in risks"
          :key="section.key"
          class="risk-section"
        >
          <div
            v-if="section.values.length > 0"
            class="section-header"
          >
            <span class="line" />
            <span>{{ section.title }}</span>
          </div>
          <div
            v-if="section.values.length > 0"
            class="section-body"
            :class="section.key"
          >
            <div
              v-for="item in section.values"
              :key="item.path"
              class="risk-item no-select"
              :class="{ clickable: item.clickable && item.count > 0 }"
              @click="handleClickHintItem(item)"
            >
              <span>{{ item.label }}</span>
              <span v-if="item.count">&nbsp;&nbsp;{{ item.count }}</span>
            </div>
          </div>
        </div>
      </div>
    </type-container>
    <hint-dialog
      v-if="hintDialogShow"
      :prop="hintDialogProp"
      @close="hintDialogShow=false"
    />
  </div>
</template>

<script>
import TypeContainer from '@/components/report/ReportTypeContainer'
import lawExamService from '@/service/law-exam'
import HintDialog from './ReportRiskHintDialog'
export default {
  name: 'BcReportSummary',
  components: { TypeContainer, HintDialog },
  data () {
    return {
      hintDialogShow: false,
      hintDialogProp: '',
      summaryProps: [
        { label: '主体资格', key: 'subject' },
        { label: '公司治理', key: 'companyGovernment' },
        { label: '劳动人事', key: 'laborPersonnel' },
        { label: '知识产权', key: 'intellectualProperty' },
        { label: '公司经营', key: 'companyManagement' },
        { label: '涉诉风险', key: 'riskOfLitigation' }
      ],
      summaryLoading: false,
      summaryInfo: {},
      risks: [
        {
          title: '高风险信息',
          key: 'high',
          values: []
        },
        {
          title: '警示信息',
          key: 'warning',
          values: []
        },
        {
          title: '检测正常',
          key: 'normal',
          values: []
        }
      ]
    }
  },
  computed: {
    companyParams () {
      return this.$route.query
    },
    companyId () {
      return this.companyParams.id
    }
  },
  mounted () {
    this.fetchSummaryAnalysis()
    this.fetchHintInfos()
  },
  methods: {
    fetchSummaryAnalysis () {
      this.summaryLoading = true
      lawExamService.fetchSummaryAnalysis(this.companyId).then(res => {
        this.summaryLoading = false
        this.summaryInfo = res.data.summaryDTO || {}
      }).catch(_ => {
        this.summaryLoading = false
      })
    },

    // 高风险：
    // 被执行信息 失信人信息 法律诉讼 经营异常 欠税公告 严重违法 资质缺失
    // execute dishonest lawSuit abnormal ownTax illegal 资质缺失
    // 警示信息：
    // 股权质押 动产抵押 开庭公告 行政处罚 司法协助 工商变更 业务资质过期
    // equity mortgage openNotice punishment judicial 工商变更 业务资质过期
    fetchHintInfos () {
      let types = [
        { 'execute': '被执行信息' }, { 'dishonest': '失信人信息' }, { 'lawSuit': '法律诉讼' }, { 'abnormal': '经营异常' },
        { 'ownTax': '欠税公告' }, { 'illegal': '严重违法' }, { 'equity': '股权出质' }, { 'mortgage': '动产抵押' }, { 'openNotice': '开庭公告' },
        { 'punishment': '行政处罚' }, { 'judicial': '司法协助' }
      ]
      types.forEach(obj => {
        let path = Object.keys(obj)[0]
        let type = obj[path]
        this.fetchHintInfo(path, type)
      })
      this.fetchChangeRecord()
      this.fetchCertificateMissing()
    },
    fetchHintInfo (path, type) {
      let params = { pageIndex: 1, pageSize: 1, name: this.companyParams.name }
      lawExamService.reportRequestInfo(path, this.companyId, params).then(res => {
        let data = res.data || {}
        let warnLevel = data.warnLevel
        let page = data.page || {}
        let entityCount = page.entityCount || 0
        let index = entityCount === 0 ? 2 : (warnLevel === 'high' ? 0 : 1)
        this.insertHintInfo(index, type, entityCount, path)
      })
    },
    // 工商变更
    fetchChangeRecord () {
      let params = { companyId: this.companyId, pageNum: 1, pageSize: 1 }
      lawExamService.reportRequestBaseInfo('changeRecord', params).then(res => {
        let data = res.data || {}
        let entityCount = data.entityCount || 0
        let index = entityCount === 0 ? 2 : 1
        this.insertHintInfo(index, '工商变更', entityCount, 'changeRecord')
      })
    },
    // 业务资质
    fetchCertificateMissing () {
      let params = { pageIndex: 1, pageSize: 1, name: this.companyParams.name }
      lawExamService.reportRequestInfo('certificateMissing', this.companyId, params).then(res => {
        let data = res.data || {}
        let level = data.level
        if (level === 'high') {
          this.insertHintInfo(0, data.name, data.count, 'certificateMissing', false)
        }
      })
    },
    insertHintInfo (index, label, count, path, clickable = true) {
      let arr = this.risks[index].values
      arr.push({ label, count, path, clickable })
    },
    handleClickHintItem (item) {
      if (item.count > 0 && item.clickable) {
        this.hintDialogProp = item.path
        this.hintDialogShow = true
      }
    }
  }
}
</script>

<style lang="stylus">
.bc-report-summary
  font-size 14px
  .summary
    .summary-slot
      padding-bottom 10px
      padding-left 10px
      .info-item
        display flex
        margin-top 26px
        .label
          width 82px
          height 30px
          border-radius 2px
          background-color #f6f6f6
          margin-right 20px
          line-height 30px
          text-align center
          font-weight 500
        .value
          flex 1
          margin-top 5px
  .risk
    .risk-section
      .section-header
        height 20px
        font-size 14px
        font-weight 500
        color #8590a6
        display flex
        align-items center
        .line
          background-color #8590a6
          display inline-block
          width 2px
          height 12px
          margin-right 8px
      .section-body
        display flex
        flex-wrap wrap
        padding 4px 0 40px
        &.high .risk-item
          color #e27777
          background-color #fff4f4
          border-color #f2b8b8
        &.warning .risk-item
          color #e6760d
          background-color #ffeede
          border-color #ffdbbb
        &.normal
          padding-bottom 10px
          .risk-item
            color #65982c
            background-color #f9fff2
            border-color #d0dfbe
        .risk-item
          height 32px
          line-height 30px
          padding 0 8px
          font-weight 500
          box-sizing border-box
          border solid 1px
          border-radius 2px
          margin-left 10px
          margin-right 2px
          margin-top 12px
          &.clickable
            cursor pointer
            &:hover
              box-shadow 0 2px 4px 0 $color-shadow
</style>
